import React from "react";
import { MdOutlineArrowBack } from "react-icons/md";
import { Link } from "react-router-dom";
import ApplicantFileAttentionTableRow from "../TableRows/ApplicantFileAttentionTableRow";

function FileAttentionTable() {
  return (
    <div>
      <div className="mt-4">
        <div className="  flex flex-col p-[24px]  rounded-t-lg bg-white">
          <div className="">
            <Link to={"/candidate/dashboard"}>
              <MdOutlineArrowBack size="24px" />
            </Link>
          </div>

          <p className="text-[14px] pt-[24px] font-[700] text-[#292727]">
            Files needing attention (3)
          </p>
        </div>
        <ApplicantFileAttentionTableRow />
      </div>
    </div>
  );
}

export default FileAttentionTable;
